export default __webpack_public_path__ + "static/media/sites-mob6.c50e69df.png";